import React from 'react';
import { RouteComponentProps } from 'react-router';

import { ButtonElem } from '../../common/button';
import { i18n } from '../../lib/lang';
import styled from 'styled-components';
import { Spacing } from '../../theme';
import { TextElem } from '../../common/text';

export const Page: React.FC<RouteComponentProps> = () => {
  const chatUrl = i18n.t('FAQ.BUTTON.LINK');

  const handleClick = () => {
    window.Telegram.WebApp.openLink(chatUrl);
    setTimeout(() => {
      window.Telegram.WebApp.close();
    }, 100);
  };

  return (
    <Layout>
      <TextElem
        color="textSecondary"
        size="medium"
        tid="COMMON.BLOCKED.TITLE"
      />
      <ButtonElem type="primary" tid="FAQ.BUTTON.TITLE" onClick={handleClick} />
    </Layout>
  );
};

const Layout = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  padding: 80px 20px 20px;
  margin: 0 auto;
  width: 100%;
  gap: ${Spacing(7)};
  flex-direction: column;
`;
